<section class="main-section-help-user-account" #top>
  <div id="assetLibraryMainSection" class="main_section_headers" i18n="@@ipos-help.asset-library.title">Asset Library</div>
  <p class="main-desc">
    <span i18n="@@ipos-help.asset-library.main-desc">IPOS maintains a library of
      <strong>Store Logos, Content Groups, Segments,</strong> and
      <strong>Attract Loop Videos</strong> that you create as part of your
      Custom Installation Profiles. This library can be reused in the
      creation of future Custom Installation Profiles.
      <span>If any videos are being uploaded as part of Content Group then these videos must be encoded using H.264. 
      H.265 is not supported.</span></span>
  </p>

  <div class="accordion" id="accetLibraryAcc">
    <!-- Section 1 - Store Logos -->
    <div id="storeLogoCard" class="card" #storeLogo>
      <div class="card-header" id="ALstoreLogoSection">
        <div id="storeLogoHeaderContent" class="card-header-content d-flex">
          <div id="storeLogoTitle" class="title"><span i18n="@@ipos-help.asset-library.store-logo-title">STORE LOGOS</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isStoreLogos" aria-controls="collapseOne"
          id="storeLogosSection"
          >
            <img (click)="showDescription('storeLogos')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isStoreLogos?'transform-180':''" />
          </div>
        </div>
      </div>
      <div
      id="storeLogosSection"
      aria-labelledby="headingOne"
      class="collapse spacing_style" id="collapseOne" data-parent="#storeLogosSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isStoreLogos"
      >
        <div id="storeLogoCardBody" class="card-body">
          <div id="storeLogoContent" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.store-logo-content">You can select a <strong>Store Logo</strong> for your IPOS
                Interface, which will appear in the bottom left corner of IPOS. By clicking on a <strong>Store Logo</strong>,
                the associated content will appear in the main display area.
                You’ll be prompted to select a
                <strong>Store Logo</strong> while installing IPOS on the
                device.</span>
            </p>
            <div id="pleaseFollow">
              <span i18n="@@ipos-help.asset-library.store-logo-please-follow">Please follow the below steps to upload a
                <strong>Store Logo</strong>:</span>
            </div>
            <ol>
              <li i18n="@@ipos-help.asset-library.store-logo-navigate-to">Navigate to the <strong>Asset Library</strong> tab and
                click on the <strong>Store Logo</strong> section.</li>

              <li i18n="@@ipos-help.asset-library.store-logo-click-upload">Click the <strong>Upload Logo</strong> button.</li>
              
              <li i18n="@@ipos-help.asset-library.store-logo-click-browse-upload">Browse and upload an image file in GIF, JPG, or PNG
                format.</li>
            </ol>
            <p>
              <span i18n="@@ipos-help.asset-library.store-logo-reuse-future"><strong>Store Logos</strong> saved in the Asset Library can
                be reused for future Custom Installation Profiles. Once you
                upload the logo, it will appear in the
                <strong>Other Logos</strong> section. You can sort the logos
                based on the <strong>Upload Date</strong> and
                <strong>File Name</strong>.</span>
            </p>

            <!-- Preview image -->
            <img class="mb-3 help-AL-store-logo" alt="Asset-Store-Logo">

            <div id="youCanText" i18n="@@ipos-help.asset-library.you-can-text">You can:</div>
            <ul>
              <li i18n="@@ipos-help.asset-library.store-logo-make-logo-default">Set a default logo by clicking the
                <strong>Set as Default</strong> button. It will be automatically assigned to the new Custom Installation Profiles you create.</li>

              <li i18n="@@ipos-help.asset-library.store-logo-change-remove">Change or remove the default logo.</li>
              <li i18n="@@ipos-help.asset-library.store-logo-delete-permanently">Click the <strong>Delete</strong> button to permanently delete a logo that may be linked to a Custom Installation Profile.</li>

              <li *ngIf="loginUserRole === 'retailHQUser'||loginUserRole === 'regionalHQ'" i18n="@@ipos-help.asset-library.store-logo-send-logo-to-stores">Send a logo to stores by clicking the <strong>Send</strong> button. Once you click on the <strong>Send</strong> button, you can search, filter, and select the required stores from the list.</li>
            </ul>
            <div id="createLogoContent">
              <span i18n="@@ipos-help.asset-library.create-logo-content"><strong>Note</strong>: You can also create a
                <strong>Logo Content Group</strong>, which will be
                associated with a <strong>Store Logo</strong>. If you have
                no logos, this tab will be disabled. Please view
                <a class="btn-link" (click)="navigate()">Adding Custom Content to IPOS</a>
                for more information.</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2 - Promotional Content -->
    <div id="promoContentCard" class="card" #promoContent>
      <div class="card-header" id="ALpromoContentSection">
        <div id="promoContentCardHeader" class="card-header-content d-flex">
          <div id="promoContentTitle" class="title"><span i18n="@@ipos-help.asset-library.promotional-content-title">PROMOTIONAL CONTENT</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isPromoContent" aria-controls="collapseTwo"
          id="promoContentSection"
          >
          <img (click)="showDescription('promoContent')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isPromoContent?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="promoContentSection"
      aria-labelledby="headingTwo"
      class="collapse spacing_style" id="collapseTwo" data-parent="#promoContentSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isPromoContent"
      >
        <div id="promoContentCardBody" class="card-body">
          <div id="promoContentCardContent" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.promotional-accessible-through-fact-tag"><strong>Promotional Content</strong> is accessed through <strong>Fact Tags</strong>.    
                It helps inform shoppers of everything from promotions, sales and rebates to tutorials or product demos.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.promotional-displayed-on-store-promo">Promotions are displayed on the Store Promo page. On clicking a <strong>Promotional Content</strong> area, 
                the associated content will appear in the main display area of IPOS.</span>
            </p>
            <ul>
              <li i18n="@@ipos-help.asset-library.promotional-dynamically-assigned-devices"><strong>Promotional Content Groups</strong> can be
                dynamically assigned to devices based on the
                manufacturer, processor model (e.g., Intel® Core™ i5 processor), processor
                generation, or device type (e.g., laptop, desktop, AIO via
                <strong>Form Factors</strong>). You can also create
                different content for Intel® devices and non-Intel devices.</li>
              <li i18n="@@ipos-help.asset-library.form-factor-selection-save-non-intel">Click <strong>Select Form Factors</strong> for form factors selection. 
                After selection of form factors, click ‘Save Selections’ to save it. 
                This will help to apply content for different manufacturers, processor models (e.g., Intel® Core™ i5), 
                processor generations, or device types (e.g., laptop, desktop, AIO). 
                You can also create different content for Intel and non-Intel devices.</li>
            </ul>
            <img class="mb-3 help-asset-promo-content" alt="asset library promo content" />
            <p>{{ formFactorChangeText }}</p>
            <ul>
              <li i18n="@@ipos-help.asset-library.promotional-custom-Installation-Package">While you can include up to
                <strong>6 Promotional Content Groups</strong>
                in a Custom Installation Package, a device can have up to
                <strong>3 Promotional Content Groups</strong> selected for
                the <strong>Show on Device</strong> function at any given time. You’ll be prompted
                to select a
                <strong>Promotional Content Group</strong> while
                installing IPOS on the device. Please review it once
                before saving.</li>

              <li i18n="@@ipos-help.asset-library.promotional-reused-future"><strong>Promotional Content Groups</strong> saved in the
                Asset Library can be reused for future Custom Installation
                Profiles.</li>
            </ul>
            <p>
              <span i18n="@@ipos-help.asset-library.promotional-adding-custom-content">Click the <strong>New Promotional Content Group</strong> button to
                create a new Promotional Content Group. Please view <a class="btn-link" (click)="navigate()">Adding Custom Content to IPOS</a> for more information.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.promotional-add-custom-Installation-Package"><strong>Note</strong>: Each
                <strong>Promotional Content Group</strong> added to a Custom
                Installation Package will increase the package size and the
                installation time.</span>
            </p>

            <!-- Preview image -->
            <img class="mb-3 help-al-promo-content" alt="promo content" />
            
            <div id="promoContentYouCan" i18n="@@ipos-help.asset-library.you-can-text">You can:</div>
            <ul>
              <li i18n="@@ipos-help.asset-library.promotional-edit-promotional-content">Edit a <strong>Promotional Content Group</strong> by
                clicking the <strong>Edit</strong>
                button.</li>
              <li i18n="@@ipos-help.asset-library.promotional-delete-permanently">Delete a <strong>Promotional Content Group</strong> that may be 
                linked to a Custom Installation Profile permanently by clicking the <strong>Delete</strong> button.</li>
              <li i18n="@@ipos-help.asset-library.promotional-expand-section">Expand the section to view more details by clicking the
                dropdown icon.</li>
              <li *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ'" i18n="@@ipos-help.asset-library.promotional-filter-select">Send a <strong>Promotional Content Group</strong> to stores by clicking the <strong>Send button</strong>. Once you click on the <strong>Send </strong>button, you can search, filter, and select the required stores from the list.</li>
              <li i18n="@@ipos-help.asset-library.user-can-set">The user has the ability to set the following options:</li>
              <ol>
                <li i18n="@@ipos-help.asset-library.user-set-publish-date-time"><strong>Publishing Date and Time</strong> while creating a New Promotional Content Group. This property can be set in two ways, <strong>Now</strong> or <strong>Custom</strong></li>
                <li i18n="@@ipos-help.asset-library.user-set-expiry-date-time"><strong>Expiration Date and Time</strong> while creating a New Promotional Content Group, it can also be set in two ways, <strong>Never</strong> or <strong>Custom</strong></li>
                <div i18n="@@ipos-help.asset-library.promo-expired-message">(<strong>Note:</strong> If a Promotional Content expires, a message that reads “<strong>This content group has expired</strong>” will be shown with Published Name)</div>
              </ol>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 3 - Segments -->
    <div id="segmentsCard" class="card" #segment>
      <div class="card-header" id="ALsegmentsSection">
        <div id="segmentsCardHeader" class="card-header-content d-flex">
          <div id="segmentsTitle" class="title"><span i18n="@@ipos-help.asset-library.segment-title">SEGMENTS</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isSegements" aria-controls="collapseThree"
          id="segmentsSection"
          >
          <img (click)="showDescription('segments')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isSegements?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="segmentsSection"
      aria-labelledby="headingThree"
      class="collapse spacing_style" id="collapseThree" data-parent="#isSegements"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isSegements"
      >
        <div id="segmentsCardBody" class="card-body">
          <div id="segmentsCardContent" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.segment-content">IPOS allows you to organize your 
                device customizations into <strong>Segment Content Groups</strong>, which can be
                used to theme your device, as each one is associated with a
                color. This also helps the sales process by letting you group
                and categorize devices based on their performance level,
                device type, color, etc. Segmenting your devices based on
                colors helps the shoppers to easily identify the right device.</span>
            </p>

            <p>
              <span i18n="@@ipos-help.asset-library.segment-navigation-bar">The <strong>Segment</strong> will appear in the top
                navigation bar and in the footer section of IPOS. By clicking a <strong>Segment</strong>, the associated
                content will appear in the main display area.</span>
            </p>

            <p>
              <span i18n="@@ipos-help.asset-library.segment-custom-installation">While you can add up to
                <strong>10 Segment Content Groups</strong> in a Custom
                Installation Package, a device can have up to
                <strong>3 Segment Content Groups</strong> selected for the <strong>Show on Device</strong> function at any given time. 
                You’ll be prompted to select a <strong>Segment</strong> while installing IPOS on
                the device.</span>
            </p>

            <div id="segmentsImpAttributes">
              <span i18n="@@ipos-help.asset-library.segment-important-attributes">A few important attributes of a
                <strong>Segment Content Group</strong> are listed below:</span>
            </div>
            <ul>
              <li i18n="@@ipos-help.asset-library.segment-published-required"><strong>Headline</strong>: This is the name it will be published under. It is a required field. 
                Example: Home, Office, Business, Gaming, etc.</li>
              <li>
                <span i18n="@@ipos-help.asset-library.segment-description-published"><strong>Sub-headline</strong>: If desired, you can include a text description of the segment. 
                  This description will be visible to shoppers.</span>
              </li>
              <li i18n="@@ipos-help.asset-library.segment-mention-retailer"><strong>Retailer Name</strong>: You can also mention the
                name of the retailer.</li>
              <li i18n="@@ipos-help.asset-library.segment-choose-theme"><strong>Segment Theme</strong>: Choose a theme color for
                the <strong>Segment Fact Tag</strong>.</li>
              <li i18n="@@ipos-help.asset-library.segment-color"><strong>Segment Color</strong>: Choose a background color
                for the <strong>Segment Fact Tag</strong>.</li>
              <li i18n="@@ipos-help.asset-library.segment-font-color"><strong>Segment Font Color</strong>: Choose a font color
                for the <strong>Segment Fact Tag</strong>. Please select a
                <strong>Font Color</strong> that will contrast with the selected background color so that the text is legible.</li>
              <li i18n="@@ipos-help.asset-library.segment-appply-color"><strong>Apply Segment Color to IPOS</strong>: If selected, 
                this option will apply the <strong>Segment</strong> color to the IPOS background.</li>
              <li i18n="@@ipos-help.asset-library.segment-form-factors"><strong>Form Factors</strong>: It helps to dynamically
                assign a <strong>Segment</strong> to devices based on the
                manufacturer, processor, generation, or device type. You
                can also create different content for Intel® devices and non-Intel devices.</li>
              <li i18n="@@ipos-help.asset-library.form-factor-selection-save-non-intel">Click <strong>Select Form Factors</strong> for form factors selection. 
                After selection of form factors, click ‘Save Selections’ to save it.
                 This will help to apply content for different manufacturers, processor models (e.g., Intel® Core™ i5), 
                 processor generations, or device types (e.g., laptop, desktop, AIO).
                 You can also create different content for Intel and non-Intel devices.</li>
            </ul>
            <img class="mb-3 help-asset-promo-content" alt="asset library promo content" />
            <p>{{ formFactorChangeText }}</p>
            <ul>
              <li i18n="@@ipos-help.asset-library.user-can-set">The user can set the following:</li>
              <ol>
                <li i18n="@@ipos-help.asset-library.user-set-segment-publish-date-time"><strong>Publishing Date and Time</strong> while creating a New Segment Content Group. This property can be set in two ways, <strong>Now</strong> or <strong>Custom</strong></li>
                <li i18n="@@ipos-help.asset-library.user-set-segment-expiry-date-time"><strong>Expiration Date and Time</strong> while creating a New Segment Content Group, it can also be set in two ways, <strong>Never</strong> or <strong>Custom</strong></li>
                <div i18n="@@ipos-help.asset-library.segment-expired-message">(<strong>Note:</strong> If a Segment Content expires, a message that reads “<strong>This content group has expired</strong>” will be shown)</div>
              </ol>
            </ul>
            <ul>
              <li i18n="@@ipos-help.asset-library.segment-image-video"><strong>Upload Image or Video</strong>: You may include either a video or an image to display with each <strong>Segment</strong>.
                Videos must be in mp4 format, less than <strong>60</strong> seconds in length and less than <strong>10 MB</strong> in size. Images must be in JPG, JPEG, PNG, JFIF or GIF format.</li>
            </ul>
            <p>
              <span i18n="@@ipos-help.asset-library.segment-reuse-futur-custom-installation"><strong>Segment Content Groups</strong> saved in the Asset
                Library can be reused for future Custom Installation
                Profiles.</span>
            </p>

            <!-- Preview image -->
            <img class="mb-3 help-al-segments" alt="segments"/>

            <p>
              <span i18n="@@ipos-help.asset-library.segment-without-description"><strong>Note</strong>: If you create a
                <strong>Segment Content Group</strong> without a description
                or asset, it will not be clickable, nor will it appear in the
                <strong>Fact Tag area</strong>.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.segment-adding-custom-information">You can also create content pages, which will be associated
                with a <strong>Segment Content Group</strong>. Please view
                <a class="btn-link" (click)="navigate()"
                  >Adding Custom Content to IPOS</a
                >
                for more information.</span>
            </p>
            <div id="segmentsContentGroup" *ngIf="loginUserRole != 'retailHQUser' && loginUserRole !== 'regionalHQ'">
              <span  i18n="@@ipos-help.asset-library.segment-edit-delete">Just as with Promotional Content Groups, you can edit, delete, expand,
                and collapse a <strong>Segment Content Group</strong>.</span>
            </div>
            <div id="segmentSendContent" *ngIf="loginUserRole === 'retailHQUser'|| loginUserRole === 'regionalHQ'">
              <span i18n="@@ipos-help.asset-library.segment-send-content">Just as with Promotional Content Groups, you can edit, delete, expand, and collapse a <strong>Segment Content Group</strong>, as well as send it to stores.</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 4 - Banner Carousel -->
    <div id="bannerCarouselCard" class="card" #banner>
      <div class="card-header" id="ALbannerCarouselSection">
        <div id="bcCardHeader" class="card-header-content d-flex">
          <div id="bannerTitle" class="title"><span i18n="@@ipos-help.asset-library.banner-title">BANNER CAROUSEL</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isBannerCarousel" aria-controls="collapseFour"
          id="bannerSection"
          >
          <img (click)="showDescription('bannerCarousel')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isBannerCarousel?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="bannerSection"
      aria-labelledby="headingFour"
      class="collapse spacing_style" id="collapseFour" data-parent="#bannerSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isBannerCarousel"
      >
        <div id="bannerCardBody" class="card-body">
          <div id="bannerCardContent" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.banner-allows-display">IPOS allows you to display up to <strong>3</strong> pages of
                rotating page content or a URL Experience in
                <strong>Banner Carousel</strong>.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.banner-third-tile">It will appear in the third tile on the home page of IPOS. By clicking a
                <strong>Banner Carousel</strong>, the associated content
                will appear in the main display area.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.banner-custom-installation-package">While you can add up to
                <strong>6 Banner Carousel Groups</strong> in a Custom
                Installation Package, a device can have up to
                <strong>3 Banner Carousel Groups</strong> selected for the
                <strong>Show on Device</strong> function at any given time. You’ll be prompted to
                select a <strong>Banner Carousel Group</strong>
                while installing IPOS on the device.</span>
            </p>
            <div id="stepsToCreateBanner">
              <span i18n="@@ipos-help.asset-library.banner-steps-to-create">Please follow the below steps to create a
                <strong>Banner Carousel Group</strong>:</span>
            </div>
            <ol>
              <li>
                <span i18n="@@ipos-help.asset-library.banner-options-available">Select a <strong>Banner Function</strong>. There are
                  <strong>2</strong> options available and you can select one
                  of them.</span>
                <ul class="banner-tab-feature-list">
                  <li i18n="@@ipos-help.asset-library.banner-customizable-pages"><strong>Content Pages</strong>: This will display up
                    to <strong>3</strong> customizable pages.</li>
                  <li i18n="@@ipos-help.asset-library.banner-launch-external-url"><strong>URL Experience</strong>: This will include
                    and launch an external URL.</li>
                </ul>
              </li>
              <li>
                <span i18n="@@ipos-help.asset-library.banner-below-details">Enter the below details:</span>
                <ul class="banner-tab-feature-list">
                  <li i18n="@@ipos-help.asset-library.banner-publish-name"><strong>Published Name</strong> (Required): Shoppers will be able to see this name.
                    You can enter up to <strong>50 characters</strong>.</li>

                  <li i18n="@@ipos-help.asset-library.banner-internal-name"><strong>Internal Name</strong>: Shoppers will not see this name; it is only meant to easily identify and  distinguish the group from other groups. 
                    You can enter up to <strong>50 characters</strong>.</li>

                  <li i18n="@@ipos-help.asset-library.banner-thumbnail"><strong>Banner Thumbnail</strong> (Required): You can
                    include an image to display with each banner. Images must be in JPG, JPEG, PNG, JFIF or GIF format.</li>
                  
                  <li i18n="@@ipos-help.asset-library.publishing-date-time"><strong>Publishing Date and Time</strong>: Select a Publishing date and time. By default, it will be ‘Now’.</li>

                  <li i18n="@@ipos-help.asset-library.banner-expiration-date-time"><strong>Expiration Date and Time</strong>: Select an Expiration Date and Time. By default, it will be <strong>Never</strong>, or it can be set using <strong>Custom</strong>.</li>
                  <div i18n="@@ipos-help.asset-library.banner-expired-message">(<strong>Note:</strong> If a Banner Content Group expires, a message that reads “<strong>This content group has expired</strong>” will be shown with a Published Name)</div>

                  <li i18n="@@ipos-help.asset-library.segment-form-factors"><strong>Form Factors</strong>: It helps to dynamically
                    assign a <strong>Banner Carousel</strong> to devices,
                    based on the. manufacturer, processor model e.g., Core
                    i5, processor generation, or device type e.g., laptop,
                    desktop, AIO. You can also create different content
                    for Intel® devices and non-Intel devices.</li>
                </ul>
              </li>
              <img class="mb-3 help-asset-promo-content" alt="asset library promo content" />
            <p>{{ formFactorChangeText }}</p>
              <!-- Preview image -->
              <img class="mb-3 help-al-banner-carousel-one"  alt="new banner carousel group"/>
              <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
              <li>
                <span i18n="@@ipos-help.asset-library.segment-after-saving">After saving and proceeding,</span>
                <ul class="banner-tab-feature-list">
                  <li i18n="@@ipos-help.asset-library.segment-select-content-page">If you have selected <strong>Content Pages</strong> as
                    <strong>Banner Function</strong>, then you can add up
                    to <strong>3</strong> pages of content. Please view
                    <a class="btn-link" (click)="navigate()"
                      >Adding Custom Content to IPOS</a
                    >
                    for more information.</li>
                  <li i18n="@@ipos-help.asset-library.segment-url-experience">If you have selected
                    <strong>URL Experience</strong> as
                    <strong>Banner Function</strong>, then you can add an
                    external URL.</li>
                </ul>
              </li>
              <!-- Preview image -->
              <!-- <img class="mb-3 help-al-banner-carousel-two" alt="url experience"/> -->
              <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
            </ol>
            <p>
              <span i18n="@@ipos-help.asset-library.segment-custom-profiles"><strong>Banner Carousel Groups</strong> saved in the Asset
                Library can be reused for future Custom Installation
                Profiles.</span>
            </p>
            <div id="editDeleteExpand" *ngIf="loginUserRole != 'retailHQUser' && loginUserRole !== 'regionalHQ'">
              <span i18n="@@ipos-help.asset-library.segment-edit-delete-expand">Just as with Promotional Content, you can edit, delete, expand, and
                collapse a <strong>Banner Carousel Group</strong>.</span>
            </div>
            <div id="editSendSegment" *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ'">
              <span i18n="@@ipos-help.asset-library.segment-edit-send">Just as with Promotional Content, you can edit, delete, expand,
                and collapse a <strong>Banner Carousel Group</strong>, as well as send it to stores.</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 5 - Price Content -->
    <div id="priceContentCard" class="card" #priceContent>
      <div class="card-header" id="ALpriceContentSection">
        <div id="priceContCardHeader" class="card-header-content d-flex">
          <div id="priceContentTitle" class="title"><span i18n="@@ipos-help.asset-library.price-title">PRICE CONTENT GROUP</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isPriceContent" aria-controls="collapseFive"
          id="priceSection"
          >
          <img (click)="showDescription('priceContent')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isPriceContent?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="priceSection"
      aria-labelledby="headingFive"
      class="collapse spacing_style" id="collapseFive" data-parent="#priceSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isPriceContent"
      >
        <div id="priceContentCardBody" class="card-body">
          <div id="priceContentDesc" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.price-display-pricing">IPOS allows you to display the pricing information of a device to shoppers. When a shopper clicks on the device’s pricing information in the footer section, the
                <strong>Price Content Group</strong> will be displayed in
                the main display area of IPOS.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.price-custom-installation-show-device">While you can add up to
                <strong>3 Price Content Groups</strong> in a Custom
                Installation Package, a device can have up to
                <strong>1 Price Content Group</strong> selected for the <strong>Show
                on Device</strong> function at any given time. You’ll be prompted to select a
                <strong>Price Content Group</strong>
                while installing IPOS on the device.</span>
            </p>
            <div id="pricePleaseFollow">
              <span i18n="@@ipos-help.asset-library.price-please-follow">Please follow the below steps to create a
                <strong>Price Content Group</strong>:</span>
            </div>
            <ol>
              <li i18n="@@ipos-help.asset-library.price-published-shoppers">Enter a <strong>Published Name</strong> of up to <strong>50 characters</strong>. This name will be visible to shoppers and is a required field.</li>
              <li i18n="@@ipos-help.asset-library.price-distinguish-groups">Enter an <strong>Internal Name</strong> of up to <strong>50 characters</strong>. This name will not be published; it is only meant to easily identify and 
                distinguish the group from other groups.</li>
              <li i18n="@@ipos-help.asset-library.price-publishdate">Select a <strong>Publishing Date and Time</strong>. By default, it will be ‘Now’.</li>
              <li i18n="@@ipos-help.asset-library.price-expire-date-time">Select an <strong>Expiration Date and Time</strong>. By default, it will be <strong>Never</strong>, or it can be set using <strong>Custom</strong>.</li>
              <div i18n="@@ipos-help.asset-library.price-expired-message">(<strong>Note:</strong> If a Price Content Group expires, a message that reads “<strong>This content group has expired</strong>” will be shown with a Published Name)</div>
              <li i18n="@@ipos-help.asset-library.price-select-form-factor">Click <strong>Select Form Factors</strong> to select device form factors. Then click ‘Save Selections’ to save. 
                This will apply to the content group, based on the selected manufacturers, processor models, processor generations, and device types. You can create different content for Intel® devices and non-Intel devices.</li>
              <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
            </ol>
            <img class="mb-3 help-asset-promo-content" alt="asset library promo content" />
            <p>{{ formFactorChangeText }}</p>

            <!-- Preview image -->
            
            <img class="mb-3 help-al-price-content" alt="new price content group"/>
            <p>
              <span i18n="@@ipos-help.asset-library.price-reused-future"><strong>Price Content Groups</strong> saved in the Asset
                Library can be reused for future Custom Installation
                Profiles.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.price-adding-custom"><strong>Note</strong>: After saving, you can add up to 3
                pages of content in the
                <strong>Price Content Group</strong>. Please view
                <a class="btn-link" (click)="navigate()"
                  >Adding Custom Content to IPOS</a
                >
                for more information.</span>
            </p>
            <div id="priceEditDelete" *ngIf="loginUserRole != 'retailHQUser' && loginUserRole !== 'regionalHQ'">
              <span i18n="@@ipos-help.asset-library.price-edit-delete-expand">Just as with Promotional Content, you can edit, delete, expand, and
                collapse a <strong>Price Content Group</strong>.</span>
            </div>
            <p>
              <span *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ'" i18n="@@ipos-help.asset-library.price-edit-delete-expand-send">Just as with Promotional Content, you can edit, delete, expand,
                and collapse a <strong>Price Content Group</strong>, as well as send it to stores.</span>
              </p>
            <div id="priceNote">
              <span i18n="@@ipos-help.asset-library.section-not-seen-contact"><strong>Note</strong>: If you do not see this section, please contact your Intel Representative to have it enabled.</span>
              <img class="ipos-help-no-price-content" alt="no-price-content">
            </div>             
          </div>
        </div>
      </div>
    </div>

    <!-- Section 6 - Attract Loop Video -->
    <div id="attractLoopCard" class="card" #attractorAsset>
      <div class="card-header" id="ALattractLoopSection">
        <div id="attractLoopCardHeader" class="card-header-content d-flex">
          <div id="attractLoopCardTitle" class="title"><span i18n="@@ipos-help.asset-library.attract-title">ATTRACT LOOP VIDEO</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isAttractLoop" aria-controls="collapseSix"
          id="attractorLoopSection"
          >
          <img (click)="showDescription('attractLoop')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isAttractLoop?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="attractorLoopSection"
      aria-labelledby="headingSix"
      class="collapse spacing_style" id="collapseSix" data-parent="#attractorLoopSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isAttractLoop"
      >
        <div id="attractLoopCardBody" class="card-body">
          <div id="attractLoopContent" class="content">
            <p>
              <span i18n="@@ipos-help.asset-library.attract-idle-exp">IPOS includes an Idle Experience to keep screens active,
                even when a shopper is not using the device. The
                <strong>Attract Loop Video</strong> is a custom creative
                experience designed to provide the Idle Experience. A single
                <strong>Attract Loop Video Content Group</strong> can be
                assigned to multiple devices while creating a Custom
                Installation Profile.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.attract-prompted-installing">You’ll be prompted to select an
                <strong>Attract Loop Video</strong> while installing IPOS on
                the device.</span>
            </p>
            <div id="attractLoopFollowText">
              <span i18n="@@ipos-help.asset-library.attract-please-follow">Please follow the below steps to create an
                <strong>Attract Loop Video</strong>:</span>
            </div>
            <ol>
              <li i18n="@@ipos-help.asset-library.price-published-shoppers">Enter a <strong>Published Name</strong> of up to <strong>50 characters</strong>.
                This name will be visible to shoppers and is a required field.</li>
              <li i18n="@@ipos-help.asset-library.price-distinguish-groups">Enter an <strong>Internal Name</strong> of up to <strong>50 characters</strong>. 
                This name will not be published; it is only meant to easily identify and
                distinguish the group from other groups.</li>
              <li i18n="@@ipos-help.asset-library.attract-upload-attract-loop">Upload an <strong>Attract Loop Video</strong>. This is a
                required field. The video must be in mp4 format, <strong>less than 60 seconds</strong> in length and less than
                <strong>10 MB</strong> in size.</li>
              <li i18n="@@ipos-help.asset-library.price-publishdate">Select a <strong>Publishing Date and Time</strong>. By default, it will be ‘Now’.</li>
              <li i18n="@@ipos-help.asset-library.price-expire-date-time">Select an <strong>Expiration Date and Time</strong>. By default, it will be <strong>Never</strong>, or it can be set using <strong>Custom</strong>.</li>
              <div i18n="@@ipos-help.asset-library.attract-expired-message">(<strong>Note:</strong> If Attract Loop Videos expires, a message that reads “<strong>This content group has expired</strong>” will be shown with Published Name)</div>
              <li i18n="@@ipos-help.asset-library.price-select-form-factor">Click <strong>Select Form Factors</strong> to select device form factors. Then click ‘Save Selections’ to save. 
                This will apply to the content group, based on the selected manufacturers, processor models, processor generations, and device types. You can create different content for Intel® devices and non-Intel devices.</li>
                <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
            </ol>

            <!-- Preview image -->
            <img class="mb-3 help-al-attractor-loop-admin" alt="new attract loop video"/>
            <img class="mb-3 help-al-attractor-loop-admin1" alt="new attract loop video"/>
            <p><span i18n="@@ipos-help.note-attract-all-select-by-default"><strong>Note</strong>: By default, ‘All’ will be selected for Device Type, Manufacturers and Generation and all processors will be selected by default except Intel® Processor, Celeron® and Pentium®.</span></p>
            <p>
              <span i18n="@@ipos-help.asset-library.attract-save-in-asset-library"><strong>Attract Loop Videos</strong> saved in the Asset
                Library can be reused for future Custom Installation
                Profiles.</span>
            </p>
            <div id="attractLoopVideo" i18n="@@ipos-help.asset-library.attract-like-promo">Just as with Promotional Content, you can edit, delete, expand, and
              collapse an <strong>Attract Loop Video</strong>.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 7 - Main Tile Asset -->
    <div id="mainTileCard" class="card" *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser' || loginUserRole === 'intelAdmin'" #main>
      <div class="card-header" id="ALmainTileAssetSection">
        <div id="mainTileCardHeader" class="card-header-content d-flex">
          <div id="mainTileCardTitle" class="title"><span i18n="@@ipos-help.asset-library.main-tile-title">MAIN TILE ASSET</span></div>
          <div
          class="table_collapse_link collapsed " data-toggle="collapse"
          [attr.aria-expanded]="isMainTileasset" aria-controls="collapseSeven"
          id="mainTileSection"
          >
          <img (click)="showDescription('mainTileAsset')" class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section" [ngClass]="isMainTileasset?'transform-180':''"/>
          </div>
        </div>
      </div>
      <div
      id="mainTileSection"
      aria-labelledby="headingSeven"
      class="collapse spacing_style" id="collapseSeven" data-parent="#mainTileSection"
                #collapse="ngbCollapse" [(ngbCollapse)]="!isMainTileasset"
      >
        <div id="mainTileCardBody" class="card-body">
          <div id="mainTileContent" class="content">
            <p><span i18n="@@ipos-help.asset-library.SRT"><strong>Intel® Shopper Recommendation Tool (SRT)</strong></span></p>
            <p>
              <span i18n="@@ipos-help.asset-library.SRT-is-content-group"><strong>Intel® Shopper Recommendation Tool (SRT)</strong> is a content group which
                offers a product recommendation experience to engage shoppers. To enable this, you can include either a URL or a zip file in the package.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.custom-installation-package">You will be able to view and select a customized <strong>Intel® Shopper Recommendation Tool (SRT)</strong> for a Custom Installation Package only if it is enabled by the Intel Admin. 
                This content group will appear in the <strong>Main Tile</strong> area (shown in blue below) of IPOS.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.call-to-action-button-in-SRT">The <strong>Call-to-Action</strong> button in the
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong> content redirects to the
                URL attached to a specific content group. The URL is
                dynamic, since it will be appended by the Store ID.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.asset-library.srt-packaged-windows-profiles">The <strong>Intel® Shopper Recommendation Tool (SRT)</strong> may be packaged with
                Windows* and Windows* in S Mode profiles.</span>
            </p>
            <div id="mainTileDeviceInternet" i18n="@@ipos-help.asset-library.main-tile-device-internet">When the device has no internet connection:</div>
            <ul>
              <li i18n="@@ipos-help.asset-library.main-tile-recommendation-experience">Clicking on the <strong>Call-to-Action</strong> button will open a
                zip file, which loads an Intel® Shopper
                Recommendation Tool experience. While the zip file is
                running, IPOS will be minimized and the shopper has to
                click on the IPOS icon to open it again.</li>
              <li i18n="@@ipos-help.asset-library.main-tile-shopping-recommendation">The zip file will only run on Windows* devices. For
                Windows* 10 S, the Intel® Shopper Recommendation Tool (SRT) will not
                be visible.</li>
            </ul>
            <!-- Preview image -->
            <img *ngIf="loginUserRole !== 'intelAdmin'" class="mb-3 help-al-main-tile-retailer" alt="SRT Retailer Main Tile">

            <p *ngIf="loginUserRole === 'intelAdmin'" i18n="@@ipos-help.asset-library.modifies-tile-content-popup">When a user modifies an existing <strong>Custom Main Tile Content Group</strong> and opts to <strong>Save Changes</strong>, 
              a pop up will display asking the user if they want to push the changes to all devices currently using that asset.</p>

            <!-- Preview image --> 
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help-al-main-tile-one" alt="view main tile assets"/>
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help-al-main-tile-two" alt="view main tile assets 1"/>
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help-al-main-tile-three" alt="view main tile assets 2"/>
            <p *ngIf="loginUserRole === 'intelAdmin'">User can send Main Tile Asset to other stores.</p>
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help-al-main-tile-four" alt="view main tile assets 3"/>
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help-al-main-tile-five" alt="view main tile assets 4"/>
            <div id="mainTileScreenCreated" *ngIf="loginUserRole === 'intelAdmin'"  i18n="@@ipos-help.asset-library.main-tile-screen-created">In the <strong>Intel® Shopper Recommendation Tool (SRT)</strong> screen all the content groups created by you will be displayed. As an Intel
              Admin, you can add, edit, delete, and send a new
              <strong>Intel® Shopper Recommendation Tool (SRT)</strong> content group to the retailers.</div>
            <ul *ngIf="loginUserRole === 'intelAdmin'">
              <li i18n="@@ipos-help.asset-library.click-edit-icon-profile">Click the edit icon on the right hand side to make any changes to the selected
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong> configuration. This will launch a workflow similar to Create an
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong>. You can update the appropriate details and save your changes.</li>

              <li i18n="@@ipos-help.asset-library.click-delete-icon-profile">Click the delete icon to delete a
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong> from the profiles using
                it. This will launch a confirmation pop-up screen. Click
                the <strong>Delete Main Tile</strong> button.</li>

              <li i18n="@@ipos-help.asset-library.click-send-icon-profile">Click the Send icon to send a
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong> to all the users of the
                Retail HQ associated with the selected
                <strong>Intel® Shopper Recommendation Tool (SRT)</strong>. This will launch a
                confirmation pop-up screen, click the
                <strong>Send Main Tile</strong> button.</li>
            </ul>

            <!-- Preview image -->
            <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 help_AL_main_tile_2" alt="send main tile assets"/>
            <ul *ngIf="loginUserRole === 'intelAdmin'">
              <li>
                <span i18n="@@ipos-help.asset-library.please-follow-below">Please follow the below steps to create a new
                  <strong>Intel® Shopper Recommendation Tool (SRT)</strong>.</span>
                <ol>
                  <li i18n="@@ipos-help.asset-library.click-SRT">Click the <strong>New Intel® Shopper Recommendation Tool (SRT)</strong> button.</li>
                  <li i18n="@@ipos-help.asset-library.navigated-SRT">You will be navigated to the
                    <strong>New Intel® Shopper Recommendation Tool (SRT)</strong>
                    screen.</li>
                  <li i18n="@@ipos-help.asset-library.main-tile-published-name">Enter a <strong>Published Name</strong> of up to <strong>50 characters</strong>. 
                    This name will be visible to shoppers and is a required field.</li>
                  <li i18n="@@ipos-help.asset-library.price-distinguish-groups">Enter an <strong>Internal Name</strong> of up to <strong>50 characters</strong>. 
                    This name will not be published; it is only meant to easily identify and distinguish the group from other groups.</li>

                  <li i18n="@@ipos-help.asset-library.main-tile-retailers-dropdown">Select the required <strong>Retail HQ</strong>.
                    Retailers whose SRT on Hero Tile is enabled will be
                    shown in the dropdown. This is a required field.</li>

                  <li i18n="@@ipos-help.asset-library.main-tile-upload-image">Upload a <strong>Main Tile Image</strong>. It must be
                    in JPG, GIF, or PNG format, with a maximum allowed size of
                    <strong>5 MB</strong> and a recommended aspect
                    ratio of <strong>18:5</strong>. The preview will update once the Hero Tile image is uploaded. This is a required field.</li>

                  <li i18n="@@ipos-help.asset-library.main-tile-call-to-action">Enter a <strong>Call-to-Action</strong> button name.
                    This is a required field.</li>
                  <li i18n="@@ipos-help.asset-library.main-tile-upload-gaming">Upload a <strong>Gaming IPOS Banner</strong>. It must
                    be in JPG, GIF, or PNG format, with a maximum allowed size of
                    <strong>5 MB</strong> and a recommended aspect ratio
                    of <strong>9:5</strong>. This is a required field.</li>
                  <li i18n="@@ipos-help.asset-library.main-tile-url-required">Enter an <strong>Intel® SRT URL</strong>. This is a
                    required field.</li>
                  <li i18n="@@ipos-help.asset-library.main-tile-fallback-zip">Upload a <strong>Fallback zip File</strong> for
                    the Main Tile. This is a required field.</li>
                  <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
                </ol>
              </li>
            </ul>

            <!-- Preview image -->
           
            <img *ngIf="loginUserRole === 'intelAdmin'" class="help_AL_main_tile_4 mb-3" alt="edit main tile assets" />
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.custom-hero-tile"><strong>CUSTOM HERO TILE</strong></span>
            </p>  
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.custom-tile-hero-feature"><strong>Custom Hero Tile</strong> is a feature which can be enabled for a Retailer by you or an Intel Admin, for a Retail HQ User by an Intel Admin, or for you or a Store User by an Intel Admin. If enabled, you or the Retailer will be able to customize the main tile of IPOS.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.create-view-edit-delete">A retail HQ, you, or a Store User will be able to
                create, view, edit and delete a customized <strong>Custom Hero Tile</strong>
                for a Custom Installation Package only if it is enabled by the Intel Admin. This content group will appear in the
                <strong>Main Tile</strong> area (displayed in blue below) of IPOS.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.call-to-action-button-detail" *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'">The <strong>Call-to-Action</strong> button in the <strong>Custom Hero Tile</strong> content redirects to the URL attached to a specific content group.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.applicable-to-windows">This is applicable to Windows*, Windows* UWP and Linux*.</span>
            </p>
            <img *ngIf="loginUserRole !== 'intelAdmin'" class="mb-3 retailHQ_view_asset_new" alt="second custom tile image">
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.crete-new-retail-HQ" *ngIf="loginUserRole === 'intelAdmin'">While creating a new Retail HQ User, you or Intel Admin can enable/disable this feature as shown below.</span>
            </p>
            <img *ngIf="loginUserRole === 'intelAdmin'" class="admin_retailHQ_popup mb-3"  alt="retailHQ popup">
            <p>
              <span i18n="@@ipos-help.ipos-help-asset.or" *ngIf="loginUserRole === 'intelAdmin'">OR</span>
              <span i18n="@@ipos-help.ipos-help-asset.content-group-created-customized" *ngIf="loginUserRole === 'retailHQUser'|| loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'">In the Custom Hero Tile screen all the content groups created and customized by you will be displayed.</span>
            </p>
            <p>
              <span *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'">
                <ul>
                  <li><span i18n="@@ipos-help.ipos-help-asset.click-delete-icon">Click the delete icon to delete a <strong>Custom Hero Tile</strong> from the profiles using it. This will launch a confirmation pop-up screen. Click the <strong>Delete Main Tile</strong> button.</span></li>
                  <li><span i18n="@@ipos-help.ipos-help-asset.click-edit-icon">Click the edit icon on the right-hand side to make any changes to the selected <strong>Custom Hero Tile</strong> configuration. This will launch a workflow similar to create a <strong>Custom Hero Tile</strong>. You can update the appropriate details and save your changes.</span></li>
                  <img class="mb-3 retailHQ_view_asset_edit_delete" alt="second custom tile image">
                  <li><span i18n="@@ipos-help.ipos-help-asset.please-follow-steps">Please follow the below steps to create a new Custom Hero Tile.</span></li>
                  <ol>
                    <li><span i18n="@@ipos-help.ipos-help-asset.click-new-tile-button">Click the <strong>New Custom Hero Tile</strong> button.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.navigate-new-custom-tile">You will be navigated to the <strong>New Custom Hero</strong> Tile screen.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.enter-published-name">Enter a <strong>Published Name</strong> of up to <strong>50 characters</strong>. This name will be visible to shoppers and is a required field.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.enter-internal-name">Enter an <strong>Internal Name</strong> of up to <strong>50 characters</strong>. This name will not be published; it is only meant to easily identify and distinguish an asset from other assets.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.upload-main-tile">Upload a <strong>Main Tile Image</strong>. It must be in JPG, GIF, or PNG format, with a maximum allowed size of <strong>5 MB</strong> and a recommended aspect ratio of <strong>18:5</strong>. The preview will update once the Hero Tile image is uploaded. This is a required field.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.upload-gaming-banner">Upload a <strong>Gaming IPOS Banner</strong>. It must be in JPG, GIF, or PNG format, with a maximum allowed size of <strong>5 MB</strong> and a recommended aspect ratio of <strong>9:5</strong>. This is a required field.</span></li>
                    <li><span i18n="@@ipos-help.ipos-help-asset.enter-call-action">Enter a <strong>Call-to-Action</strong> button name. This is a required field.</span></li>
                    <li i18n="@@ipos-help.asset-library.user-can-set">The user can set the following:</li>
                        <ol>
                          <li i18n="@@ipos-help.asset-library.user-set-custom-publish-date-time"><strong>Publishing Date and Time</strong> while creating a New Custom Main Tile Content. This property can be set in two ways, <strong>Now</strong> or <strong>Custom</strong></li>
                          <li i18n="@@ipos-help.asset-library.user-set-custom-expiry-date-time"><strong>Expiration Date and Time</strong> while creating a New Custom Main Tile Content, it can also be set in two ways, <strong>Never</strong> or <strong>Custom</strong></li>
                          <div i18n="@@ipos-help.asset-library.custom-expired-message">(<strong>Note:</strong> If a Custom Main Tile Content expires, a message that reads “<strong>This content group has expired</strong>” will be shown with Published Name)</div>
                        </ol>
                    <li><span i18n="@@ipos-help.ipos-help-asset.select-features">Select features for the devices to which the content group needs to be sent by clicking on <strong>Select Form Factors</strong>. A pop-up window will open showing various features that can be applied to devices which you can select/deselect according to your requirement.</span></li>
                    <li i18n="@@ipos-help.partner-portal.page-click-save-and-proceed-text">Click the <strong>Save and Proceed</strong> button.</li>
                  </ol>
                </ul>
              </span>
              <span *ngIf="loginUserRole === 'intelAdmin'" i18n="@@ipos-help.ipos-help-asset.for-existing-retailHQ">For an existing Retail HQ user, you or Intel Admin can enable/disable this feature as shown below.</span>
            </p>
            <p>
              <img class="mb-3 asset_library_retail" *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'" alt="down-img-one">
              <img class="mb-3 help-asset-promo-content"  *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'regionalHQ' || loginUserRole === 'storeUser'" alt="down-img-two">
              <img *ngIf="loginUserRole === 'intelAdmin'" class="mb-3 custom_tile_button" alt="intel-admin image">
            </p>
            
              <span i18n="@@ipos-help.installation-package.heading.note-label"
                *ngIf="loginUserRole !== 'intelAdmin'"><strong>Note</strong>:</span>
              <ul *ngIf="loginUserRole !== 'intelAdmin'">
                <li><span i18n="@@ipos-help.ipos-help-asset.regional-retail-notified-email">When a Regional User/Retail HQ User sends an asset to one or more stores, the recipients will be notified by email.</span></li>
                <li><p i18n="@@ipos-help.ipos-help-asset.email-user-receive-content">The following notification email will be sent
                  to Store Users when they receive a content group.</p></li>
                <img class="mb-3 custom-tile-email-one" alt="custom-tile-email">
                <li><p i18n="@@ipos-help.ipos-help-asset.notification-user-receive-logo">The following notification email will be
                  sent to Store Users when they receive a logo.</p></li>
                <img class="mb-3 custom-tile-email-two" alt="custom-tile-email1">
              </ul>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
